import React from 'react';
import { useHistory } from 'react-router-dom';

import useStoreTranslation from 'hooks/useStoreTranslation';
import ResponseScreen, { BackgroundTypes, IconTypes } from 'screens/components/ResponseScreen';

type Props = {
  show: boolean;
};

const CompanyProfileSuccess = ({ show }: Props) => {
  const { t } = useStoreTranslation();
  const history = useHistory();

  const handleButtonClick = () => history.replace('/dashboard');

  return (
    <ResponseScreen
      show={show}
      background={BackgroundTypes.Mountain}
      icon={IconTypes.Airplane}
      text={t('companyProfileSuccess.title')}
      subText={t('companyProfileSuccess.detail')}
      buttonOnClick={handleButtonClick}
      buttonText={t('companyProfileSuccess.ok')}
    />
  );
};

export default CompanyProfileSuccess;
